/** @module Slices */
import { createSlice } from '@reduxjs/toolkit'
import { User } from 'types'

const initialState: User = {
  id: 0,
  firstName: '',
  lastName: '',
  email: '',
  bio: '',
  position: '',
  roles: [],
  token: '',
  refreshToken: '',
  tokenExpiry: null
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearLoginState: (state) => {
      state = initialState
      return state
    },
    setCredentials: (state, action) => {
      console.log('setCredentials called with payload:', action.payload)
      state.token = action.payload.token
      const expiry = action.payload.tokenExpiry || action.payload.expires
      // Convert Unix timestamp (seconds) to ISO string
      if (expiry) {
        const expiryMs = typeof expiry === 'number' ? expiry * 1000 : expiry
        state.tokenExpiry = new Date(expiryMs).toISOString()
      } else {
        state.tokenExpiry = null
      }
      state.id = action.payload.id
      state.email = action.payload.email
      state.roles = action.payload.roles || []
      state.firstName = action.payload.details?.first_name || ''
      state.lastName = action.payload.details?.last_name || ''
      state.position = action.payload.position || ''
      console.log('setCredentials updated state:', {
        token: !!state.token,
        tokenExpiry: state.tokenExpiry,
        roles: state.roles,
        email: state.email
      })
      return state
    },
    logoutUser: (state) => {
      state = initialState
      return state
    }
  }
})

export const { clearLoginState, setCredentials, logoutUser } = userSlice.actions
